import styled from "styled-components"
import { device } from "breakpoints"
import { Button } from "components/Button"

export const AcknoledgementStatementContainer = styled.div`
  width: 100vw;
  min-height: 100vh;
  position: fixed;
  overflow: scroll;
  top: 0;
  left: 0;
  z-index: 200;
  visibility: ${props => (props.shown ? "visible" : "hidden")};
  opacity: ${props => (props.shown ? 0.95 : 0)};
  pointer-events: ${props => (props.shown ? "all" : "none")};
  transition: opacity 400ms;
  display: flex;
  background-image: linear-gradient(-36deg, #629d1b 0%, #009bc2 100%);
  padding: 85px 0;

  @media ${device.desktop} {
    padding-top: 125px;
  }

  > div {
    flex-direction: column;
    align-items: center;
    position: relative;
    @media ${device.desktop} {
      max-width: 830px;
    }
    p {
      font-size: 18px;
      color: white;
      font-weight: 500;
      font-weight: 600;
      text-align: center;
      line-height: 130%;
      margin-bottom: 20px;
      @media ${device.desktop} {
        margin-bottom: 35px;
        font-size: 28px;
        line-height: 115%;
      }
    }

    svg.logo {
      height: 44px;
      width: 80px;
      flex-shrink: 0;
      margin-bottom: 20px;
      margin-top: 14px;
      @media ${device.desktop} {
        width: 110px;
        height: 60px;
        margin-bottom: 30px;
      }
    }

    img.moth {
      height: 60px;
      width: 60px;
      margin-bottom: 24px;
      @media ${device.desktop} {
        width: 72px;
        height: 72px;
        margin-bottom: 47px;
      }
    }
  }
`

export const Close = styled.button`
  outline: none;
  border: none;
  background: none;
  position: absolute;
  right: 40px;
  top: 40px;
  cursor: pointer;
  @media ${device.desktop} {
    top: 80px;
    right: 80px;
  }

  svg {
    height: 14px;
    width: 14px;
    transition: 100ms;
    :hover {
      opacity: 0.7;
    }
  }
`

export const EnterButton = styled(Button)`
  font-weight: 500;
  font-size: 16px;
  color: #ffffff;
  letter-spacing: -0.12px;
  text-align: center;
  align-items: center;
  line-height: 24px;
  background-color: transparent;
  border: 2px solid #ffffff;
  border-radius: 25px;
  font-weight: 600;
  width: 250px;
  margin-top: 20px;

  @media ${device.desktop} {
    font-size: 20px;
    letter-spacing: -0.16px;
  }

  :hover {
    opacity: 0.7;
  }
`
